import React from 'react';
import Immutable from 'immutable';
import Wizard from '../../containers/wizard';

const EMPTY_LIST = Immutable.List([]);

export default function WizardDefinition() {
	if (!(this instanceof WizardDefinition)) {
		return new WizardDefinition();
	}

	let selectedStepIdPath;
	let stepDefinitions;
	let stepMap;

	let contentClassName;

	const updateStepMap = function() {
		stepMap = {};
		stepDefinitions.forEach(def => {
			stepMap[def.getId()] = def;
		});
	};

	this.setContentClassName = function(value) {
		contentClassName = value;
		return this;
	};


	this.getItems = function() {
		return stepDefinitions;
	}

	this.setSteps = function(value) {
		stepDefinitions = Immutable.List(value);
		stepDefinitions.forEach(item => {
			item._parentDefinition = this;
		});
		updateStepMap();
		return this;
	};

	this.setSelectedStepIdPath = function(value) {
		selectedStepIdPath = value;
		return this;
	};

	const processButtonAction = async function(ctx, process) {
		if (process) {
			const newStepId = await process(ctx);
			if (newStepId) {
				ctx.setProperty(selectedStepIdPath, newStepId);
			}
		}
	};

	this.render = function(ctx, key = 0) {
		let selectedStepId = ctx.getProperty(selectedStepIdPath) || '__default';
		let selectedStep = stepMap[selectedStepId];
		if (!selectedStep) {
			selectedStep = stepDefinitions.get(0);
		}
		let contentDefinition = selectedStep.getContent();
		return (
			<Wizard
				contentClassName={contentClassName}
				header={selectedStep.getHeader(ctx)}
				nextButtonText={selectedStep.getNextButtonText(ctx)}
				prevButtonText={selectedStep.getPrevButtonText(ctx)}
				nextButtonAction={async () => {
					processButtonAction(ctx, selectedStep.getNextButtonAction());
				}}
				prevButtonAction={async () => {
					processButtonAction(ctx, selectedStep.getPrevButtonAction());
				}}
			>
				{
					contentDefinition ? contentDefinition.render(ctx, selectedStepId) : null
				}
			</Wizard>
		);
	};
}
